const getRoomURL = (room: Room): string => {
  return room.url;
};

export { getRoomURL };
